var _defs, _rect, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusDivider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900.02 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#71cacd;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 26.75,
    width: 900.02,
    height: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 450.01,
    cy: 27.5,
    r: 27.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M446.56,37.86c.1-1.31.25-2.59.43-3.83s.41-2.46.67-3.66c-.73,0-1.45,0-2.13-.05s-1.39,0-2.13,0a16,16,0,0,1-1.66-.08,9,9,0,0,1-1.58-.27A2.79,2.79,0,0,1,439,29.3a1.48,1.48,0,0,1-.48-1.14,1.42,1.42,0,0,1,1.35-1.51c1.42-.16,2.87-.27,4.34-.35s3-.09,4.5,0c.21-.79.41-1.58.59-2.37s.36-1.61.52-2.45c.1-.53.23-1.06.39-1.62a6.74,6.74,0,0,1,.59-1.46,3.36,3.36,0,0,1,.87-1,1.53,1.53,0,0,1,2.41,1.34c-.11,1.32-.27,2.63-.48,3.94s-.47,2.66-.78,4a34.39,34.39,0,0,1,7.65,1.82c.74.26,1.09.6,1.07,1s-.49.64-1.39.64a29.14,29.14,0,0,1-4.22.47q-2.09.07-4.14,0a42.64,42.64,0,0,1-1.62,4.1,36.9,36.9,0,0,1-2,3.79c-.42.69-.85,1-1.27.87S446.35,38.76,446.56,37.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusDivider);
export default __webpack_public_path__ + "static/media/plus-divider.86c77a678e856e446afe12736bcd60aa.svg";
export { ForwardRef as ReactComponent };